/**
 * Parse the sample-data JSON editor (shared by the translation preview and the
 * test-dispatch dialog) into a plain object. Anything that isn't a JSON object
 * — array, primitive, or malformed text — is rejected so the caller can surface
 * an "invalid JSON" hint instead of silently dispatching garbage. An empty /
 * whitespace-only string is a valid empty object (`{}`).
 */
export type ParsedSampleData =
  { readonly data: Record<string, unknown> } | { readonly error: true };

export function parseSampleData(json: string): ParsedSampleData {
  if (json.trim() === "") return { data: {} };
  try {
    const parsed: unknown = JSON.parse(json);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return { error: true };
    }
    return { data: parsed as Record<string, unknown> };
  } catch {
    return { error: true };
  }
}
